module.exports = __webpack_public_path__ + "img/progress-bar.1e91da6b.png";